export const TEXT_LINE_LIMIT = 10;
export const TEXT_LINE_MAX_LENGTH = 120;

type BannerContent = {
  kind?: string | null;
  imageUrl?: string | null;
  textLines?: string[] | null;
};

export function bannerTextLines(lines?: string[] | null) {
  return (lines ?? []).map((line) => line.trim()).filter(Boolean);
}

export function bannerHasContent(banner?: BannerContent | null) {
  if (!banner) return false;
  if (banner.kind === "TEXT") return bannerTextLines(banner.textLines).length > 0;
  return Boolean(banner.imageUrl);
}
